import { buildModelManager } from "../builder.js";
const DefaultRecurringServiceTypeSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  deletedAt: true,
  description: true,
  intervalDays: true,
  name: true,
  paymentAmount: true,
  paymentStructure: true,
  profileId: true,
  updatedAt: true
};
const modelApiIdentifier = "recurringServiceType";
const pluralModelApiIdentifier = "recurringServiceTypes";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultRecurringServiceTypeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultRecurringServiceTypeSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultRecurringServiceTypeSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultRecurringServiceTypeSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultRecurringServiceTypeSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultRecurringServiceTypeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultRecurringServiceTypeSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createRecurringServiceType",
    operationReturnType: "CreateRecurringServiceType",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      recurringServiceType: { required: false, type: "CreateRecurringServiceTypeInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultRecurringServiceTypeSelection
  },
  {
    type: "action",
    operationName: "bulkCreateRecurringServiceTypes",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateRecurringServiceTypesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultRecurringServiceTypeSelection
  },
  {
    type: "action",
    operationName: "updateRecurringServiceType",
    operationReturnType: "UpdateRecurringServiceType",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      recurringServiceType: { required: false, type: "UpdateRecurringServiceTypeInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultRecurringServiceTypeSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateRecurringServiceTypes",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateRecurringServiceTypesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultRecurringServiceTypeSelection
  },
  {
    type: "action",
    operationName: "deleteRecurringServiceType",
    operationReturnType: "DeleteRecurringServiceType",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteRecurringServiceTypes",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "restoreRecurringServiceType",
    operationReturnType: "RestoreRecurringServiceType",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      recurringServiceType: { required: false, type: "RestoreRecurringServiceTypeInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultRecurringServiceTypeSelection
  },
  {
    type: "action",
    operationName: "bulkRestoreRecurringServiceTypes",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkRestoreRecurringServiceTypesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultRecurringServiceTypeSelection
  },
  {
    type: "action",
    operationName: "upsertRecurringServiceType",
    operationReturnType: "UpsertRecurringServiceType",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      recurringServiceType: { required: false, type: "UpsertRecurringServiceTypeInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateRecurringServiceTypeResult": { hasReturnType: false },
      "... on UpdateRecurringServiceTypeResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultRecurringServiceTypeSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertRecurringServiceTypes",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertRecurringServiceTypesInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultRecurringServiceTypeSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "recurringServiceTypeGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const RecurringServiceTypeManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultRecurringServiceTypeSelection,
  operations
);
export {
  DefaultRecurringServiceTypeSelection,
  RecurringServiceTypeManager
};
//# sourceMappingURL=RecurringServiceType.js.map
